define('models/Team',[
    'lib/lodash4',
    'lib/knockout',
    'util/ObservableModel'
], function( _, ko,ObservableModel ) {
    "use strict";


    /**
     * Model that represents teams
     */
    return ObservableModel.extend({
        defaults: {
            id          : '',
            name        : '',
            description : '',
            memberCount : 0 ,
            selfUri     : ''
        }
    }, function(){
        var self = this;

        self.unwrap = function () {
            return ObservableModel.unwrap(self, [
                "unwrap",
                "isTeam"
            ]);
        };
    });
});
